import { BlockClamp, Point } from "pytha";
import { HvacTunnelConnectT } from "../models/HvacTunnelConnectT";


export class ConnectClamp extends BlockClamp {

    onPointerMove = (event) => {
        this.point_move.set(this.extraContext.mousePosContext.x, this.extraContext.mousePosContext.y, this.extraContext.mousePosContext.z);
        if (this.capturePoint) {
            this.point_move.copy(this.capturePoint);
        } else if (this.orthogonalPoint) {
            this.point_move.copy(this.orthogonalPoint);
        } else if (this.polarPoint) {
            this.point_move.copy(this.polarPoint);
        }
        this._helpLine.setValue('end', this.point_move);
        this._helpLine.updateViewGeometry();
        let dir = this.point_move.clone().sub(this.attachPoint).normalize();
        let dist = this.point_move.clone().sub(this.attachPoint).length();

        let point = dir.clone().multiplyScalar(dist).add(this.attachPoint);
        this.attachPoint.copy(point)

        this._entityClone.move(dir, dist);

        if (this.entity.isJoint) {
            if (!this.capturePoint) {
                if (this.rotateBasePoint) {
                    this._entityClone.recoverRotate(this.point_move)
                    this.rotateBasePoint = null
                }
            }

            // 被Tunnel中心点捕捉，旋转接头
            if (this.captureEntityUuid) {
                // 是否未被旋转过
                if (this.rotateBasePoint == null) {
                    let midEntity = this.extraContext.getCurrentViewEditor().entityDict[this.captureEntityUuid]
                    if (midEntity.type == "TunnelT") {
                        this.rotateBasePoint = new Point(this.capturePoint.x, this.capturePoint.y, this.capturePoint.z)
                        let tuEntity = midEntity as any
                        let faceNormal = tuEntity?.getCaptureNormal(this.rotateBasePoint)
                        if (faceNormal) {
                            let face = tuEntity._geo.bottomFace
                            let axisX = face.axisX.clone().normalize()
                            this._entityClone.rotateByFace(this.rotateBasePoint, faceNormal, axisX, this.key)
                        } else {
                            this.rotateBasePoint = null
                        }
                    } else if (midEntity.type == 'HvacTunnelConnectT' && (midEntity as HvacTunnelConnectT)?.isJoint) {
                        // 根据接头进行旋转
                        this.rotateBasePoint = new Point(this.capturePoint.x, this.capturePoint.y, this.capturePoint.z)
                        let axisList = (midEntity as HvacTunnelConnectT).getNormalAndAxisxByCapture(this.capturePoint)
                        if (axisList.length > 0) {
                            this._entityClone.rotateByFace(this.rotateBasePoint, axisList[0], axisList[1], this.key)
                        }
                    }
                }
            }
        }

        this._entityClone.updateViewGeometry();
    }

}